import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import LoadingCircular from "../LoadingCircular";
import { Divider } from "@mui/material";

export default function OrderStatus() {
  const [activeStep, setActiveStep] = React.useState(-1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [requestId, setRequestId] = React.useState("");
  const [steps, setSteps] = React.useState([
    {
      label: "ثبت پیشنهاد",
      description: "",
    },
    {
      label: "تایید مشتری",
      description: "",
    },
    {
      label: "تایید واحد فروش",
      description: "",
    },
    {
      label: "تایید مدیریت",
      description: "",
    },
    {
      label: "تایید مالی",
      description: "",
    },
    {
      label: "مجوز تولید",
      description: "",
    },
    {
      label: "مجوز خروج",
      description: "",
    },
    {
      label: "حواله انبار",
      description: "",
    },
    {
      label: "فاکتور فروش",
      description: "",
    },
  ]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const res = await fetch(`/ng/api/RequestTracker/${requestId}`);
    const data = await res.json();
    setIsLoading(false);
    if (data === null)
      alert("برای شناسه وارد شده اطلاعاتی برای نمایش وجود ندارد");
    else {
      const active_step = data[data.length - 1].Step - 1;
      setSteps(
        steps.map((step, index) =>
          index === active_step
            ? { ...step, description: data[data.length - 1].StatusChangeDT }
            : step
        )
      );
      setActiveStep(active_step);
    }
  };

  return (
    <>
      <LoadingCircular open={isLoading} />
      <Stack
        component="form"
        spacing={1.5}
        noValidate
        autoComplete="off"
        onSubmit={onSubmit}
      >
        <LoadingCircular open={isLoading} />
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          پیگیری وضعیت سفارش
        </Typography>
        <TextField
          required
          label="کد رهگیری"
          variant="standard"
          onChange={(e) => {
            setRequestId(e.target.value);
          }}
        />
        <Button type="submit" variant="contained">
          پیگیری
        </Button>
      </Stack>
      <Box sx={{ maxWidth: 400, mt: 2 }}>
        {activeStep >= 0 && (
          <>
            <Divider>آخرین وضعیت سفارش</Divider>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    optional={
                      index === 8 ? (
                        <Typography variant="caption">اتمام فرایند</Typography>
                      ) : null
                    }
                  >
                    {step.label}
                  </StepLabel>
                  <StepContent>
                    <Typography>{step.description}</Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </>
        )}
      </Box>
    </>
  );
}
